import { useEffect } from 'react';

/**
 * Hook to handle www to non-www redirect for canonical URL consistency.
 * In production, redirects www.bwestudios.com to bwestudios.com.
 * 
 * Note: For best performance, this redirect should also be configured
 * at the DNS/CDN level (e.g., Cloudflare, Netlify, Vercel).
 */
export const useWwwRedirect = () => {
  useEffect(() => {
    const hostname = window.location.hostname;
    
    // Only redirect in production environment
    if (hostname.startsWith('www.')) {
      const newHostname = hostname.replace('www.', '');
      const newUrl = `${window.location.protocol}//${newHostname}${window.location.pathname}${window.location.search}${window.location.hash}`;
      
      // Use replace to avoid adding to browser history
      window.location.replace(newUrl);
    }
  }, []);
};
